export enum CalculationModeEnum {
  rent = 'RENT',
  all = 'ALL',
}
